import React, { useState } from "react"
import { TextLink, TextSmall } from "../../atoms/text"
import { ShowNotFoundWithMessage } from "./DropdownPopper"
import styled from "styled-components"
import { theme } from "../../../theme"

export const useDropdownNotFoundHook = <TValue,>(
  showNotFoundWithMessage: ShowNotFoundWithMessage<TValue> | undefined,
  selectedValues: TValue[],
  setSelectedValues: [TValue[], React.Dispatch<React.SetStateAction<TValue[]>>][1],
  onChange?: (newValue: TValue[]) => void | Promise<void>,
  multiple: boolean = false
) => {
  if (!showNotFoundWithMessage) return undefined

  const [isAddNew, setIsAddNew] = useState<boolean>()
  const renderAddNewPopper = () => showNotFoundWithMessage.notFoundPopper

  const goBackCallback = () => {
    setIsAddNew(false)
  }

  const internalOnAdd = async () => {
    const val = await showNotFoundWithMessage.onAdd()
    if (val) {
      const newSelected = multiple ? [...selectedValues, val] : [val]
      setSelectedValues(newSelected)
      onChange && onChange(newSelected)
      setIsAddNew(false)
    }
  }

  const renderNotFoundDropdownMessage = () => {
    return (
      <NotFoundContent>
        <TextDisclaimer>{showNotFoundWithMessage?.notFoundText}</TextDisclaimer>
        <CustomTextLink onMouseDown={() => setIsAddNew(true)}>
          {showNotFoundWithMessage?.notFoundLinkText}
        </CustomTextLink>
      </NotFoundContent>
    )
  }

  const popperAddNew = {
    addNewText: showNotFoundWithMessage.notFoundLinkText,
    onBack: goBackCallback,
    onAdd: internalOnAdd,
  }

  return {
    isAddNew: isAddNew,
    setIsAddNew: setIsAddNew,
    renderAddNewPopper: renderAddNewPopper,
    renderNotFoundDropdownMessage: renderNotFoundDropdownMessage,
    popperAddNewProps: popperAddNew,
  }
}

const NotFoundContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.m};
  padding: ${theme.spacing.l} ${theme.spacing.l} 0 ${theme.spacing.l};
`

const TextDisclaimer = styled(TextSmall)`
  color: ${(props) => props.theme.secondaryColor};
`

const CustomTextLink = styled(TextLink)`
  color: ${(props) => props.theme.primaryColor};
  :hover {
    color: ${(props) => props.theme.primaryColor};
    text-decoration: none;
  }
`
